import { msg } from '@lingui/core/macro';
import { useLingui } from '@lingui/react/macro';
import classNames from 'classnames';
import { Pages } from 'modules/navigation/domain/enums/pages';
import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import type { MessageDescriptor } from 'shared/i18n';
import UDTabs from 'ud-ui/components/tabs';
import { Tab } from 'ud-ui/components/tabs/interfaces';
import UDText from 'ud-ui/components/text';
import { PlayerViewTab } from 'modules/players/domain/enums/player-view-tab';

/** Подписи и порядок вкладок; hash-и — в `PlayerViewTab`, они часть роута. Переводятся в рендере. */
const PLAYER_VIEW_TABS: { hash: PlayerViewTab; label: MessageDescriptor }[] = [
  { hash: PlayerViewTab.COMMON, label: msg`Основные данные` },
  { hash: PlayerViewTab.TEAMS, label: msg`Команды` },
  { hash: PlayerViewTab.MOMENTS, label: msg`Моменты` },
];

type CreateEditFormParams = {
  tab: Tab;
  count?: number;
  isActive?: boolean;
  state?: any;
};

const createEditFormTab = (params: CreateEditFormParams): Tab => {
  const { tab, count, isActive, state } = params;

  if (count !== undefined) {
    const badgeBgColor = isActive ? 'bg-surfaceWhite' : 'bg-accentNaplesYellow';
    const className = classNames([
      'text-surfaceRaisinBlack50',
      badgeBgColor,
      'p-1',
      'rounded-[4px]',
      'ml-2',
      'line-height-1',
      'caption-1',
    ]);

    return {
      hash: tab.hash,
      label: (
        <>
          {tab.label}{' '}
          <UDText type="subhead" className={className}>
            {count}
          </UDText>
        </>
      ),
    };
  }

  return { ...tab, state };
};

type PlayerEditFormTabsProps = {
  state?: any;
};

const PlayerEditFormTabs = ({ state }: PlayerEditFormTabsProps) => {
  const { t } = useLingui();
  const location = useLocation();
  const activeTab = (location.pathname || '').split('/').at(-1);

  const tabs = useMemo(() => {
    return PLAYER_VIEW_TABS.map((tab) =>
      createEditFormTab({
        tab: { hash: tab.hash, label: t(tab.label) },
        isActive: tab.hash === activeTab,
        state: state,
      }),
    );
  }, [t, activeTab, state]);

  return <UDTabs tabs={tabs} defaultTab={tabs[0]} activeRoutePattern={Pages.PLAYERS.VIEW} />;
};

export default PlayerEditFormTabs;
